import { FreeRoundBonusDialog } from "../Dialogs/FreeRoundBonusDialog";
import { ModuleManager } from "../../../Managers/ModuleManager";
import { GameManager } from "../../../Managers/GameManager";
import { FreeRoundBonusIcon } from "../Dialogs/FreeRoundBonusIcon";
import { FreeRoundBonus } from "./FreeRoundBonus";

export class FreeRoundBonusExtended extends FreeRoundBonus {
    public static activateOffer(): void {
        if (FreeRoundBonus.status === "active") {
            FreeRoundBonus.inFrb = true;
            FreeRoundBonusIcon.showIcon("active");
            ModuleManager.disableBase();
            GameManager.softInit();
        } else {
            ModuleManager.disableBase();
        }
    }

    public static declineOffer(): void {}

    public static initializeFreeRounds(): void {
        FreeRoundBonusDialog.initialize();
        FreeRoundBonusIcon.initialize();
    }

    public static showFreeRounds(): void {
        FreeRoundBonus.openOther();
    }

    public static endFreeRounds(): void {}
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/Channels/Common/Bonuses/FreeRoundBonusExtended.ts
 **/